// ─── Add ─────────────────────────────────────────────────────────────────────
export const selectAddBatchesData = (state) => state?.batches?.addBatches?.data;
export const selectAddBatchesLoading = (state) => state?.batches?.addBatches?.loading;
export const selectAddBatchesError = (state) => state?.batches?.addBatches?.error;

// ─── Update ──────────────────────────────────────────────────────────────────
export const selectUpdateBatchesData = (state) => state?.batches?.updateBatches?.data;
export const selectUpdateBatchesLoading = (state) => state?.batches?.updateBatches?.loading;
export const selectUpdateBatchesError = (state) => state?.batches?.updateBatches?.error;

// ─── List ────────────────────────────────────────────────────────────────────
export const selectBatchesList = (state) => state?.batches?.getBatchesList?.data || [];
export const selectBatchesListLoading = (state) => state?.batches?.getBatchesList?.loading;
export const selectBatchesListError = (state) => state?.batches?.getBatchesList?.error;
export const selectBatchesListTotal = (state) => state?.batches?.getBatchesList?.total || 0;

// ─── Detail ──────────────────────────────────────────────────────────────────
export const selectBatchesDetail = (state) => state?.batches?.getBatchesDetail?.data;
export const selectBatchesDetailLoading = (state) => state?.batches?.getBatchesDetail?.loading;
export const selectBatchesDetailError = (state) => state?.batches?.getBatchesDetail?.error;
export const selectBatchesDetailTotal = (state) => state?.batches?.getBatchesDetail?.total || 0; // ✅ NEW

// ─── Delete ──────────────────────────────────────────────────────────────────
export const selectDeleteBatchesData = (state) => state?.batches?.deleteBatches?.data;
export const selectDeleteBatchesLoading = (state) => state?.batches?.deleteBatches?.loading;
export const selectDeleteBatchesError = (state) => state?.batches?.deleteBatches?.error;

// ─── Unassigned Employees ────────────────────────────────────────────────────
export const selectUnassignedEmployees = (state) => state?.batches?.getUnassignedEmployees?.data || [];
export const selectUnassignedEmployeesLoading = (state) => state?.batches?.getUnassignedEmployees?.loading;
export const selectUnassignedEmployeesError = (state) => state?.batches?.getUnassignedEmployees?.error;

// ─── Add Employees to Batch ──────────────────────────────────────────────────
export const selectAddEmployeesToBatchData = (state) => state?.batches?.addEmployeesToBatch?.data;
export const selectAddEmployeesToBatchLoading = (state) => state?.batches?.addEmployeesToBatch?.loading;
export const selectAddEmployeesToBatchError = (state) => state?.batches?.addEmployeesToBatch?.error;

// ─── Remove Employees from Batch ─────────────────────────────────────────────
export const selectRemoveEmployeesFromBatchData = (state) => state?.batches?.removeEmployeesFromBatch?.data;
export const selectRemoveEmployeesFromBatchLoading = (state) => state?.batches?.removeEmployeesFromBatch?.loading;
export const selectRemoveEmployeesFromBatchError = (state) => state?.batches?.removeEmployeesFromBatch?.error;

// ─── Batch Options (dropdown) ─────────────────────────────────────────────────
export const selectBatchesOptions = (state) => state?.batches?.getBatchesOptions?.data || [];
export const selectBatchesOptionsLoading = (state) => state?.batches?.getBatchesOptions?.loading;
export const selectBatchesOptionsError = (state) => state?.batches?.getBatchesOptions?.error;

// ─── Move Employees ───────────────────────────────────────────────────────────
export const selectMoveBatchEmployeesData = (state) => state?.batches?.moveBatchEmployees?.data;
export const selectMoveBatchEmployeesLoading = (state) => state?.batches?.moveBatchEmployees?.loading;
export const selectMoveBatchEmployeesError = (state) => state?.batches?.moveBatchEmployees?.error;

// ─── Full State ──────────────────────────────────────────────────────────────
export const selectBatchesState = (state) => state?.batches;